import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const ProtectedRoute = ({ children, roles }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  // While AuthContext is validating the session (including the
  // authAPI.getSession() background check), show a neutral loading screen.
  // Do NOT make any routing decision until loading is complete.
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white">
        <div className="loading-shimmer w-32 h-8 rounded-lg"></div>
      </div>
    );
  }

  // Authorization is based solely on the server-validated `user` from
  // AuthContext. The localStorage fallback is intentionally removed:
  // a stale or demoted role cached in storage must not grant route access.
  if (!user) {
    sessionStorage.setItem('redirectAfterLogin', location.pathname + location.search);
    return <Navigate to="/" replace />;
  }

  if (roles && !roles.includes(user.role)) {
    // Redirect to the dashboard matching the user's actual server-side role
    switch (user.role) {
      case 'admin':
        return <Navigate to="/admin/dashboard" replace />;
      case 'business_head':
        return <Navigate to="/business-head/dashboard" replace />;
      case 'employee':
      case 'vendor':
        return <Navigate to="/employee/dashboard" replace />;
      default:
        return <Navigate to="/" replace />;
    }
  }

  return children;
};

export default ProtectedRoute;